import { planTypes } from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { plansof } from '@/utils/chain';
import store from '@/store';

export const PLAN_TYPES_WITH_MULTI_BASE_PLANS = [planTypes.ROOM_CONNECTOR];

const ZoomRoomAsUrlBasePlanAndZoomMeetingAsBasePlan = () => {
  const { plan = 'pro' } = pageConfig;
  const { subscriptions = [], getSelectedPlans = [] } = store?.getters; 
  // https://zoomvideo.atlassian.net/browse/ZOOM-601091
  // url: https://deva.zoomdev.us/opc/buy/config?plan=zsched&subPlan=allSubPlan&type=basic2pro&from=zr
  // Zsched free trial user try to add zr & pro
  const isZschedFreeTrialBought = plansof(subscriptions).filter((plan) => getPlanTypeByCategory(plan?.category || '') === planTypes.ZOOM_SCHEDULER).freeTrial().has();
  // adding room & pro can add crc
  const isMultipleBasePlansInShoppingCart = plansof(getSelectedPlans).type(planTypes.ZOOM_MEETING, planTypes.ZOOM_ROOMS).has(2 /* Means two base plan: room & pro */);
  // at this circumstance, `plan` not means what user's base plan, `from` is not means what user want to buy, `basic2pro` flow is actually a type of ft add2cart flow.
  if(!!isZschedFreeTrialBought && !!isMultipleBasePlansInShoppingCart) {
    return true;
  }
  return isZoomMeetingAsAddonCard() && getPlanTypeByCategory(plan) === planTypes.ZOOM_ROOMS;
};

export const checkIfMultipleBasePlanDependencies = () => {
  const { type: pageFlowType } = pageConfig;
  return (
    // 0. Must buy flow
    (pageFlowType === flowTypes.basic2pro || pageFlowType === flowTypes.buyNow) &&
    // 1. [CRC] needs zoom room or zoom one as base plan, but zoom one prioritize than zoom room
    ZoomRoomAsUrlBasePlanAndZoomMeetingAsBasePlan()
  );
};
